import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { EquipmentItem } from './po-line-item.model'
import { PoCommonFieldsComponent } from './po-common-fields.component'

@Component({
    selector: 'app-equipment-form',
    templateUrl: './equipment-form.component.html',
    standalone: true,
    imports: [FormsModule, PoCommonFieldsComponent],
})
export class EquipmentFormComponent {
    item = input.required<EquipmentItem>()
}
